module.exports = __webpack_public_path__ + "static/media/stockhausen_cats_1.cfafaccb.jpg";